// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__OFZd3","dividerWrapper":"Divider_dividerWrapper__ajFRc"};